module.exports = __webpack_public_path__ + "img/project19_1.png.5161c644.webp";